const BASE_PRODUCTS = ["Çay", "Türk Kahvesi", "Filtre Kahve"];
const ESPRESSO_BASED_NAME = "Espresso Bazlı";

export const groupEspressoBased = (consumptionList) => {
  if (!Array.isArray(consumptionList)) return [];

  const grouped = new Map(
    [...BASE_PRODUCTS, ESPRESSO_BASED_NAME].map((name) => [
      name,
      { productName: name, consument: 0, deviceCount: 0, firmCount: 0 },
    ])
  );

  consumptionList.forEach((item) => {
    const productName = item?.productName;
    const targetName = BASE_PRODUCTS.includes(productName)
      ? productName
      : ESPRESSO_BASED_NAME;

    const current = grouped.get(targetName);
    if (!current) return;

    current.consument += item?.consument || 0;
    current.deviceCount += item?.deviceCount || 0;
    current.firmCount += item?.firmCount || 0;
  });

  return Array.from(grouped.values());
};

export const formatCompactCurrency = (value) => {
  if (value >= 1_000_000_000) {
    const v = value / 1_000_000_000;
    return `${v >= 100 ? Math.trunc(v).toLocaleString("tr-TR") : v >= 10 ? (Math.trunc(v * 10) / 10).toLocaleString("tr-TR") : (Math.trunc(v * 100) / 100).toLocaleString("tr-TR")} Mr`;
  }
  if (value >= 1_000_000) {
    const v = value / 1_000_000;
    return `${v >= 100 ? Math.trunc(v).toLocaleString("tr-TR") : v >= 10 ? (Math.trunc(v * 10) / 10).toLocaleString("tr-TR") : (Math.trunc(v * 100) / 100).toLocaleString("tr-TR")} M`;
  }
  if (value >= 1_000) {
    const v = value / 1_000;
    return `${v >= 100 ? Math.trunc(v).toLocaleString("tr-TR") : v >= 10 ? (Math.trunc(v * 10) / 10).toLocaleString("tr-TR") : (Math.trunc(v * 100) / 100).toLocaleString("tr-TR")} B`;
  }
  return value.toLocaleString("tr-TR");
};

export const deduplicateNotOrderedFirms = (firms) => {
  const byId = {};
  firms.forEach((f) => {
    const id = String(f._id ?? f.firmId ?? "");
    if (!id) return;
    if (!byId[id]) {
      byId[id] = {
        firmName: f.firmName,
        _id: f._id,
        firmId: f.firmId,
        email: f.email,
        bayserNo: f.bayserNo,
        products: [f],
      };
    } else {
      byId[id].products.push(f);
    }
  });
  return Object.values(byId);
};

const SESSION_EXPIRY_REASONS = {
  token_version_mismatch: "another_device",
  account_not_fully_verified: "account_not_verified",
  trusted_device_revoked: "trusted_device_revoked",
};

export const handleSocketSessionExpiry = (reason) => {
  const logoutReason = SESSION_EXPIRY_REASONS[reason];
  if (logoutReason) {
    try { sessionStorage.setItem("logoutReason", logoutReason); } catch (_) {}
    window.dispatchEvent(new CustomEvent("session-expired", { detail: { reason: logoutReason } }));
    return true;
  }
  if (["token_expired", "password_changed", "user_not_found"].includes(reason)) {
    try { sessionStorage.setItem("logoutReason", "session_expired"); } catch (_) {}
    window.dispatchEvent(new CustomEvent("session-expired", { detail: { reason: "session_expired" } }));
    return true;
  }
  return false;
};
